import { PushPin } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

const data = [
  { text: "pages.ipfs.infura.title", link: "/ipfs/infura", icon: <PushPin /> },
  { text: "pages.ipfs.pinata.title", link: "/ipfs/pinata", icon: <PushPin /> },
  { text: "pages.ipfs.web3Storage.title", link: "/ipfs/web3-storage", icon: <PushPin /> },
  { text: "pages.ipfs.nft3Storage.title", link: "/ipfs/nft-storage", icon: <PushPin /> },
];

export const IpfsSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.integrations.ipfs" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </StyledPaper>
  );
};
